import React from "react";
import { useToaster } from "utils";

import { PaziaButton, PaziaTooltip } from "components/atoms";

interface ToggleReadinessButtonProps {
  onReady: (courseId: number) => Promise<any>;
  onUnready: (courseId: number) => Promise<any>;
  invalidate: () => Promise<any>;
  isReady: boolean;
  courseId: number;
  readyText: string;
  currentStatus?: string;
}
export const ToggleReadinessButton = ({
  isReady,
  courseId,
  readyText,
  onReady,
  onUnready,
  invalidate,
  currentStatus = "Aktualny status",
}: ToggleReadinessButtonProps) => {
  const { showSuccess } = useToaster();

  const onReadyHandler = async () => {
    await onReady(courseId);
    showSuccess("Zmieniono status: gotowe.");
    invalidate();
  };

  const onUnreadyHandler = async () => {
    await onUnready(courseId);
    showSuccess("Zmieniono status: niegotowe");
    invalidate();
  };

  if (isReady)
    return (
      <div className="mt-4 flex items-center justify-between gap-2 text-emerald-500">
        {readyText} <PaziaButton title="Anuluj" type="tertiary" onClick={onUnreadyHandler} btnType="button" />
      </div>
    );
  return (
    <div className="">
      <div className="flex gap-1">
        <span>{currentStatus}: </span>
        <b>Niezatwierdzone</b>
        <PaziaTooltip
          description={
            <span>
              <b>Zatwierdzenie</b> jest finalną formą potwierdzenia poprawności, należy go dokonać przed uruchomieniem
              kursu.
            </span>
          }
        />
      </div>
      <div className="text-primary-500 cursor-pointer font-semibold hover:underline" onClick={onReadyHandler}>
        Zatwierdź
      </div>
    </div>
  );
};
